import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CreditCheckResponse } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

// **************************************************************************
// CREDIT CHECKS ACTIONS (list operations - prepared for future use)
// **************************************************************************
export const CreditChecksActions = createActionGroup({
    source: "Data / Credit Checks",
    events: {
        "Load": emptyProps(),
        "Load Success": props<{ items: CreditCheckResponse[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
